type IGetSubscriptionState = () => Promise<{
    isPushEnabled: boolean;
    isOptedOut: boolean;
}>;

// https://documentation.onesignal.com/docs/web-push-custom-code-examples#section-trigger-custom-link-prompt
export const getSubscriptionState: IGetSubscriptionState = () => {
    if (!window?.OneSignal?.isPushNotificationsEnabled || !window?.OneSignal?.isOptedOut) {
        return Promise.reject('No access to isPushNotificationsEnabled or isOptedOut');
    }

    return Promise.all([window.OneSignal.isPushNotificationsEnabled(), window.OneSignal.isOptedOut()]).then(result => {
        const isPushEnabled = result[0];
        const isOptedOut = result[1];

        return {
            isPushEnabled,
            isOptedOut,
        };
    });
};
